import Vue from 'vue'
import Vuex from 'vuex'
//  import websocket from './modules/websocket'
import editableTabs from './modules/editableTabs'
//  import createLogger from '../plugins/logger'


Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    //  websocket,
    editableTabs
  },
  strict: debug,
  //  plugins: debug ? [createLogger()] : []
})


